import { ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withSizes } from 'react-sizes';

import Header from './header';
import { toggleSideNav } from 'client/ducks/app/actions';
import { DispatchProps } from '@components/header/header';
import { withAppData } from 'client/contexts/app-data';
import { mapSizesToProps } from 'client/helpers/sizes';

const mapDispatchToProps = { toggleSideNav };

export default compose<ComponentType>(
    connect<null, DispatchProps>(null, mapDispatchToProps),
    withRouter,
    withAppData,
    withSizes(mapSizesToProps)
)(Header);
